import React 				from 'react';
import ReactDOM 			from 'react-dom';
import ReactJson			from 'react-json-view';
import BLComponent			from '../../core/_BLComponent.jsx';

export default class NothingToShow extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 
	}

	render()
	{
		const {itemType, strSearchKeyword} = this.props.data;
		const strItem = (itemType=="P")?"part":(itemType=="G")?"gear":(itemType=="B")?"book":(itemType=="M")?"minifigure":(itemType=="S")?"set":(itemType=="C")?"catalog":"";
		const emptyMsg = this.getListEmptyMsg();
		
		return(
			<section id="MPI-nothingToShow-text" className="personal-inventory__list-body l-margin-top--xxl text--center ">
				<i className="fas fa-clipboard-list inventory-comparison__nothing-to-show-icon"></i>
				<div className="inventory-comparison__nothing-to-show-context l-flex l-column l-center">
					<div className="text--darkest16 text--title text--bold">Nothing to show</div>
					<div className="text--darkest16 personal-inventory__short-message-box l-margin-bottom--xxxl">
						{emptyMsg}
						{ (strSearchKeyword.trim() != "")&&
							<div className="l-margin-top">Please try a different search term.</div>
						}
					</div>
				</div>
			</section>
		)
	}

	getListEmptyMsg() 
	{
		const {itemType, strSearchKeyword} = this.props.data;
		const strItem = (itemType=="P")?"part":(itemType=="G")?"gear":(itemType=="B")?"book":(itemType=="M")?"minifigure":(itemType=="S")?"set":(itemType=="C")?"catalog":"";
		
		if (strSearchKeyword.trim() == "")
		{
			return ( "It looks like you don’t have any " + ( (itemType!="G")?strItem + "s":strItem ) + " in your collection. Search for " + ( (itemType!="G")?"a":"" ) + " " + strItem + " above to add it." );
		}
		else
		{
			return ( "We searched high and low, but couldn't find anything for \"" + strSearchKeyword + "\" in your collection." );
		}
	}



};

